import React from 'react';
import { useFieldArray, ArrayPath, UseFormReturn } from 'react-hook-form';

import { CustomerCreateDTO } from '_lib/api/apiTypes.shim';

import { Button } from '_lib/components/Button/Button';
import { Grid } from '_lib/components/Grid/Grid';
import { TextFieldFormItem } from '_lib/components/TextFieldFormItem/TextFieldFormItem';

import { BaseAddressForm } from './BaseAddressForm';
import { ContactListFormItem } from './ContactListFormItem';

interface locationCreateFormItemProps {
  locationFieldId: string;
  locationIndex: number;
  /**
   * This component is only to be used as a child of a form that is driven by 'CustomerCreateDTO'
   */
  formContext: UseFormReturn<CustomerCreateDTO>;
  locationRemove?: (index?: number | number[] | undefined) => void;
}

export const LocationCreateFormItem = (props: locationCreateFormItemProps): React.ReactElement => {
  const { locationFieldId, locationIndex, formContext, locationRemove } = props;

  const { control } = formContext;

  const contactsPath: ArrayPath<CustomerCreateDTO> = `locations.${locationIndex}.contacts`;
  const {
    fields: locationContactFields,
    append: locationContactAppend,
    remove: locationContactRemove
  } = useFieldArray<CustomerCreateDTO>({
    name: contactsPath,
    control
  });

  return (
    <Grid key={locationFieldId} container spacing={1}>
      <Grid item xs={12} sm={12}>
        <TextFieldFormItem name={`locations.${locationIndex}.name`} label='Name' control={control} required />
      </Grid>
      <BaseAddressForm
        isNested
        formContext={formContext}
        nestedPath={`locations.${locationIndex}`}
        isEditingExisting={false}
      />
      <Grid item xs={12} sm={12}>
        <ContactListFormItem
          contactFields={locationContactFields}
          contactsPath={contactsPath}
          contactAppend={locationContactAppend}
          contactRemove={locationContactRemove}
        />
      </Grid>
      {locationRemove && (
        <Grid item xs={12} sm={2} container direction='row' sx={{ alignSelf: 'center', justifyContent: 'flex-end' }}>
          <Button variant='outlined' color='error' text='Delete' onClick={() => locationRemove(locationIndex)} />
        </Grid>
      )}
    </Grid>
  );
};
